module.exports = __webpack_public_path__ + "img/img-havePermission.3d503460.png";